
import React from 'react';
import { compose, branch, renderComponent } from 'recompose';
import { hot } from 'react-hot-loader';
import { Segment, Label, Image } from 'semantic-ui-react';

import { withLocale } from 'op/components/locale';
import { withReportSignatures } from './report-signature.helper';
import SignatureModal from './signature-modal';

export const ReportSignatrueReadonly = ({ locale, report }) => 
  report 
    && report.signatures 
    && (report.signatures.SSOSig || report.signatures.EmpSig) > 0 
    && (
      <Segment>
        <Image.Group fluid size='medium' style={{ display: 'flex', justifyContent: 'space-around' }}>
          <Image rounded bordered src={ report.signatures.SSOSig } label={{ color: 'red', content: locale.sso, ribbon: true }} />
          <Image rounded bordered src={ report.signatures.EmpSig } label={{ color: 'blue', content: locale.sso, ribbon: true }} />
        </Image.Group>
      </Segment>
    )

const ReportSignatrue = ({ locale, ready, report, readOnly, registerSignatrue, saveSignatrues }) => (
	<Segment loading={!ready}>
		<Label>{ locale.sso }</Label>
    <SignatureModal report={report} type='SSOSig' color='red' registerSignatrue={registerSignatrue} saveSignatrues={saveSignatrues} />

		<Label>{ locale.emp }</Label>
    <SignatureModal report={report} type='EmpSig' color='blue' registerSignatrue={registerSignatrue} saveSignatrues={saveSignatrues} />
	</Segment>
);

export default compose(
  hot(module),
	withLocale('report.signature'),
	withReportSignatures,
  branch(
    ({ readOnly }) => readOnly,
    renderComponent(ReportSignatrueReadonly),
  ),
)(ReportSignatrue);